import { render, staticRenderFns } from "./duty.vue?vue&type=template&id=c5a7dece&scoped=true&"
import script from "./duty.vue?vue&type=script&lang=js&"
export * from "./duty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5a7dece",
  null
  
)

export default component.exports